export default {
  title: 'SAAS超级运价系统',
  description: '智能运价查询和管理系统',

  // 通用地址字段
  address: {
    detailAddress: '详细地址',
    postalCode: '邮编',
    district: '区域'
  },

  // 通用显示字段
  display: {
    totalItems: '共 {count} 个{name}',
    port: '港口',
    pod: '目的港',
    pol: '起运港',
    warehouse: '仓库',
    warehouseCode: '仓库代码',
    region: '区域'
  },

  // 第三方地址选择组件
  thirdPartyAddressSelect: {
    country: '国家',
    state: '州',
    city: '市',
    district: '区域',
    township: '乡/镇/街道',
    postalCode: '邮编（可选）',
    postalCodePlaceholder: '请输入邮编',
    detailAddress: '详细地址',
    detailAddressPlaceholder: '请输入详细地址',
    countryPlaceholder: '请选择国家',
    statePlaceholder: '请选择州',
    cityPlaceholder: '请选择市',
    districtPlaceholder: '请选择区域',
    townshipPlaceholder: '请选择乡/镇/街道',
    error: {
      country: '选择国家失败，请重试',
      state: '选择州失败，请重试',
      city: '选择市失败，请重试',
      district: '选择区域失败，请重试'
    }
  },

  // 重置功能专用国际化
  reset: {
    buttonText: '重置',
    confirmTitle: '确认重置',
    confirmMessage: '确认要重置并清空所有字段吗？',
    confirmButton: '确认',
    cancelButton: '取消',
    successMessage: '已重置所有字段'
  },

  // 枚举翻译
  enums: {
    // 约价性质枚举
    pricingNature: {
      selfPricing: 'FAK',
      customerPricing: '客户约价',
      overseasAgentPricing: '海外代理约价',
      noPricing: '无约价',
      peerPricing: '同行约价',
      bcoContract: 'NAC/FIX',
      afcPricing: 'AFC约价',
      mixedPricing: '配比约价'
    },

    // 适用品名枚举
    commodity: {
      fak: 'FAK',
      dangerousGoods: '危险品',
      specialContainer: '特种柜',
      frozenGoods: '冷冻货',
      chemicalGoods: '化工品',
      textileGoods: '纺织品',
      other: '其他'
    },

    // 舱保枚举
    spaceGuarantee: {
      guarantee20: '有 (20 TEU/月)',
      guarantee50: '有 (50 TEU/月)',
      guarantee100: '有 (100 TEU/月)',
      guarantee300: '有 (300 TEU/月)',
      noGuarantee: '无'
    },

    // 合约状态枚举
    contractStatus: {
      enabled: '启用',
      disabled: '禁用'
    }
  },

  // 根级别的常用字段翻译
  freeContainerDays: '免用箱天数',
  demurrageFreeDays: '免堆存天数',

  // 配送地址类型
  deliveryAddressType: {
    thirdParty: '第三方地址',
    amazon: '亚马逊仓库',
    yicang: '易仓'
  }
}
